import React, { useState, useEffect, useRef } from "react";
import { alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Swal from "sweetalert2";
import DeleteIcon from "@mui/icons-material/Delete";

import MenuIcon from "@mui/icons-material/Menu";
import Avatar from "@mui/material/Avatar";
import GlobalSnackbar from "../../shared/utils/GlobalSnackbar";
import RefreshIcon from "@mui/icons-material/Refresh";
import VendorReferenceAssignmentModal from "./VendorDetails/VendorReferenceAssignmentModal";
import Badge from "@mui/material/Badge";

import {
  FormControl,
  InputLabel,
  Select,
  Menu,
  MenuItem,
  DialogActions,
  DialogTitle,
  TextField,
  Dialog,
  DialogContent,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { CircularProgress, Tooltip, IconButton } from "@mui/material";
import PublicIcon from "@mui/icons-material/Public";
import Pagination from "@mui/material/Pagination";
import FormatDateTimestamp from "../../helperFunctions/FormatDateTimestamp";
import VendorOnboardingForm from "../../shared/createForms/vendorOnboardingForm";
import { downloadData } from "../../shared/downloadData";
import axios from "axios";
import moment from "moment-timezone";
import MenuButtonWithDatePickers from "../../shared/utils/DateFilter";
import Chip from "@mui/material/Chip";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Styles from "../../styles/vendorDashboard.module.css";
import { handleFileUploadForVendorOnboarding } from "./VendorDetails/uploadExcelSheetForVendorOnboarding";
import { downloadExcelForVendorOnboarding } from "./VendorDetails/downloadExcelSheetForVendorOnboarding";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import CurrencyRupeeOutlinedIcon from "@mui/icons-material/CurrencyRupeeOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import BlockIcon from "@mui/icons-material/Block";
import TableRowsIcon from "@mui/icons-material/TableRows";
import {
  DownloadIcon,
  User_plus,
  FileDownloadIcon,
  FileUploadIcon,
} from "../../shared/assets/icons/index";
import VendorModal from "./VendorDetails/vendorModal";
import CustomLoading from "../../shared/utils/CustomLoading";
import VendorPaymentsModal from "../../shared/createForms/VendorPaymentsModal";
import OtpVerificationModal from "../../shared/utils/OtpVerificationModal";
import Decrypt from "../../shared/utils/Decrypt";
import GoogleMapModal from "../../shared/utils/GoogleMapModal";
import styles from "../../styles/adminPortal.module.css";
import GlobalDropdownField from "../../shared/utils/GlobalDropdownField";
import VendorTabs from "./vendorTabs";
import DeletedUsersRestore from "../../shared/createForms/DeletedUsersRestore";
import { CheckCircle, PersonAddAlt } from "@mui/icons-material";
import IPAssignModal from "./Campaign/IpAssignModal";
import GlobalButton from "../../shared/utils/GlobalButton.jsx";
import { useNavigate, useSearchParams } from "react-router-dom";

let userRole = localStorage.getItem("role");
function EnhancedTableHead(props) {
  return (
    <TableHead className={styles.tableHead}>
      <TableRow>
        {props.headCells.map((headCell, index) => (
          <TableCell
            key={headCell.id}
            className={styles.tableCell}
            sx={{
              minWidth: headCell.width,
            }}
          >
            <span className={styles.headCellHeading}>{headCell.label}</span>
            <div className={styles.topBorderDiv}>
              {/* Only show search input for "addedBy" if role is not 2 */}
              {headCell.id === "addedBy" && userRole === "2" ? null : (
                <>
                  {[
                    "state",
                    "city",
                    "addedBy",
                    "updatedBy",
                    "source",
                    // "status",
                    "badge",
                    // "auditStatus",
                    "vendorBusinessName",
                    "machines",
                    "machineImages",
                  ].includes(headCell.id) ? (
                    headCell.id === "machines" ? (
                      <GlobalDropdownField
                        name="machinesFilter"
                        variant="searchDropdown"
                        value={
                          props.searchInputs?.[headCell.id]
                            ? props.searchInputs[headCell.id]
                                .charAt(0)
                                .toUpperCase() +
                              props.searchInputs[headCell.id].slice(1)
                            : ""
                        }
                        onChange={(e) =>
                          props.handleSearchChangeHead(e, headCell.id)
                        }
                        placeholder="Select Machine type"
                        options={[
                          { value: "both", label: "Both" },
                          { value: "printing", label: "Printing" },
                          { value: "fabrication", label: "Fabrication" },
                          {
                            value: "Only Fabrication",
                            label: "Only Fabrication",
                          },
                          { value: "Only Printing", label: "Only Printing" },
                          // { value: "none", label: "No Machine" }, // Uncomment if needed
                        ]}
                        counts={{
                          both: props?.machineCounts?.both || 0,
                          printing: props?.machineCounts?.printing || 0,
                          fabrication: props?.machineCounts?.fabrication || 0,
                          "Only Fabrication":
                            props?.machineCounts?.["onlyFabrication"] || 0,
                          "Only Printing":
                            props?.machineCounts?.["onlyPrinting"] || 0,
                        }}
                        renderValueFn={(selected) => selected}
                      />
                    ) : headCell.id === "machineImages" ? (
                      <GlobalDropdownField
                        variant="searchDropdown"
                        name="machineImagesFilter"
                        value={props.searchInputs?.[headCell.id] || ""}
                        onChange={(e) =>
                          props.handleSearchChangeHead(e, headCell.id)
                        }
                        placeholder="Filter Images"
                        options={[
                          { value: "", label: "All" },
                          { value: "complete", label: "Complete" },
                          { value: "incomplete", label: "Incomplete" },
                        ]}
                        counts={{
                          "": props?.machineImageCounts?.all || 0,
                          complete: props?.machineImageCounts?.complete || 0,
                          incomplete:
                            props?.machineImageCounts?.incomplete || 0,
                        }}
                        renderValueFn={(selected) => {
                          if (selected === "complete") return "Complete";
                          if (selected === "incomplete") return "Incomplete";
                          return "All";
                        }}
                      />
                    ) : headCell.id === "status" ? (
                      <GlobalDropdownField
                        variant="searchDropdown"
                        name="statusFilter"
                        value={props.searchInputs?.[headCell.id] || ""}
                        onChange={(e) =>
                          props.handleSearchChangeHead(e, headCell.id)
                        }
                        placeholder="Select Status"
                        options={[
                          { value: "active", label: "Active" },
                          { value: "inactive", label: "Inactive" },
                          { value: "blacklisted", label: "Blacklisted" },
                        ]}
                        renderValueFn={(selected) => {
                          const labels = {
                            active: "Active",
                            inactive: "Inactive",
                            blacklisted: "Blacklisted",
                          };
                          return (
                            labels[selected] || selected || "Select Status"
                          );
                        }}
                      />
                    ) : headCell.id === "badge" ? (
                      <GlobalDropdownField
                        variant="searchDropdown"
                        name="statusFilter"
                        value={props.searchInputs?.[headCell.id] || ""}
                        onChange={(e) =>
                          props.handleSearchChangeHead(e, headCell.id)
                        }
                        placeholder="Select Badge"
                        options={[
                          { value: "platinum", label: "Platinum" },
                          { value: "gold", label: "Gold" },
                          { value: "silver", label: "Silver" },
                          { value: "none", label: "None" },
                        ]}
                        renderValueFn={(selected) => {
                          const labels = {
                            platinum: "Platinum",
                            gold: "Gold",
                            silver: "Silver",
                            none: "None",
                          };
                          return labels[selected] || selected || "Select Badge";
                        }}
                      />
                    ) : headCell.id === "auditStatus" ? (
                      <GlobalDropdownField
                        variant="searchDropdown"
                        name="auditStatusFilter"
                        value={props.searchInputs?.[headCell.id] || ""}
                        onChange={(e) =>
                          props.handleSearchChangeHead(e, headCell.id)
                        }
                        placeholder="Select AuditStatus"
                        options={[
                          { value: "", label: "All" },
                          { value: "verified", label: "Verified" },
                          { value: "unverified", label: "Unverified" },
                        ]}
                        renderValueFn={(selected) => {
                          if (selected === "") return "All"; // ✅ important
                          const labelMap = {
                            verified: "Verified",
                            unverified: "Unverified",
                            rejected: "Rejected",
                          };
                          return labelMap[selected] || selected;
                        }}
                      />
                    ) : (
                      // Normal text input for other columns
                      <input
                        type="text"
                        className={styles.searchInput}
                        placeholder={`Search ${headCell.label.toLowerCase()}...`}
                        onChange={(e) => {
                          props.handleSearchChangeHead(e, headCell.id);
                        }}
                        value={props.searchInputs?.[headCell.id] || ""}
                      />
                    )
                  ) : (
                    <></>
                  )}
                </>
              )}
            </div>
          </TableCell>
        ))}
      </TableRow>
      {!props.tableLoading && props.filteredVPCount > 0 && (
        <TableRow sx={{ lineHeight: "14px" }}>
          <TableCell
            colSpan={props.headCells.length}
            sx={{
              backgroundColor: "#DEEBFF",
              position: "relative",
              paddingBottom: "2rem",
              overflow: "hidden",
              lineHeight: "16px",
            }}
          >
            <div className="fixed  left-1/2 transform -translate-x-1/2 text-sm font-medium bg-[#DEEBFF] h-[1.5rem] ml-[2.6%]">
              <div className="h-full w-full flex justify-center items-center">
                {`${props.filteredVPCount} Vendor Partners`}
              </div>
            </div>
          </TableCell>
        </TableRow>
      )}
    </TableHead>
  );
}

function EnhancedTableToolbar(props) {
  // Use a ref to target the hidden file input

  const fileInputRef = React.useRef(null);
  const [open, setOpen] = useState(false);
  const [rotate, setRotate] = useState(false);
  const [clearDateFilter, setClearDateFilter] = useState(false);
  const userRole = localStorage.getItem("role");

  const [active, setActive] = useState(
    userRole == "-1" ? "Approved" : "Pending",
  );

  const handleClickRefresh = () => {
    setClearDateFilter(true);
    //// clean all filters
    props.setSearchInputs({
      state: "",
      city: "",
      vendorBusinessName: "",
      addedBy: "",
      status: "",
      auditStatus: "",
      machines: "",
      fromDate: "",
      toDate: "",

      adminApproval:
        active === "Blacklisted"
          ? "-2"
          : active === "Approved"
            ? "1"
            : active === "Pending"
              ? "0"
              : "-1",
    });

    setRotate(true);
    props.userVenderData();
    props.setPageSize(10);
    setTimeout(() => setRotate(false), 1000); // Reset animation after 500ms
  };

  const handleIconClick = () => {
    // Trigger the file input click when the icon is clicked
    fileInputRef.current.click();
  };
  const handleMapOpen = () => {
    props.setIsMapState(true);
    setOpen(false);
  };

  const { numSelected } = props;
  const handleDateChange = (e) => {
    if (e?.dateFilter) {
      // props.onDateChange(e);
      props.setSearchInputs((prev) => ({
        ...prev,
        fromDate: e.dateFilter.fromDate,
        toDate: e.dateFilter.toDate,
      }));
    }
    setOpen(false);
  };

  const handleOpen = (e) => {
    props.OnModalOpen(true);
    props.setSelectedVendorData({});
    setOpen(false);
  };
  const handleTrashOpen = async (e) => {
    props.getALLDeletedVendors();
    props.OnTrashModalOpen(true);
  };

  const handleOpenModal = () => {
    setOpen(true);
  };
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleDateClose = () => {
    setAnchorEl(null);
  };
  const handleTableOpen = () => {
    props.setIsMapState(false);
    setOpen(false);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <div className="border-b flex justify-between items-center h-20 pt-2">
      {!isMobile && (
        <>
          <div className="flex-col font-bold text-md text-gray-600">
            Total Vendor : {props.totalVendors}
            <VendorTabs
              approvalCounts={props.approvalCount}
              handleSearchChangeHead={props.handleSearchChangeHead}
              setActive={setActive}
              active={active}
            />
          </div>

          <div className="flex">
            <Tooltip title="Refresh">
              <IconButton
                onClick={handleClickRefresh}
                sx={{
                  animation: rotate
                    ? "rotateAnimation 0.5s ease-in-out"
                    : "none",
                  "@keyframes rotateAnimation": {
                    "0%": { transform: "rotate(0deg)" },
                    "100%": { transform: "rotate(360deg)" },
                  },
                }}
              >
                <RefreshIcon />
              </IconButton>
            </Tooltip>
            {(localStorage.getItem("role") == "-1" ||
              localStorage.getItem("role") == "1") && (
              <div>
                <Tooltip title="Map view">
                  <IconButton onClick={handleMapOpen}>
                    <PublicIcon
                      sx={{
                        backgroundColor: props.isMapState
                          ? "#418cff"
                          : "inherit",
                        color: props.isMapState ? "#ffff" : "inherit",
                        borderRadius: 2,
                        strokeWidth: 1.5,
                        p: "2px",
                      }}
                    />
                  </IconButton>
                </Tooltip>
              </div>
            )}

            {(localStorage.getItem("role") == "-1" ||
              localStorage.getItem("role") == "1") && (
              <div className="mr-2">
                <Tooltip title="Table view">
                  <IconButton onClick={handleTableOpen}>
                    <TableRowsIcon
                      sx={{
                        backgroundColor: props.isMapState
                          ? "inherit"
                          : "#418cff",
                        color: props.isMapState ? "inherit" : "#fff",
                        borderRadius: 2,
                        strokeWidth: 1.5,
                        p: "2px",
                      }}
                    />
                  </IconButton>
                </Tooltip>
              </div>
            )}
            {(localStorage.getItem("role") == "-1" ||
              localStorage.getItem("role") == "1") && (
              <div
                className="date-filter"
                onClick={(event) => {
                  if (anchorEl) {
                    // handleDateClose(); // Close the popover if it's open
                  } else {
                    setAnchorEl(event.currentTarget); // Open the popover
                  }
                }}
              >
                {
                  <MenuButtonWithDatePickers
                    onSubmit={handleDateChange}
                    anchorEl={anchorEl}
                    setAnchorEl={setAnchorEl}
                    handleClose={handleDateClose}
                    clearDateFilter={clearDateFilter}
                  />
                }
              </div>
            )}
            {localStorage.getItem("role") != "1" &&
              localStorage.getItem("role") != 4 && (
                <Tooltip title="Add Vendor" onClick={handleOpen}>
                  <IconButton>
                    <User_plus />
                  </IconButton>
                </Tooltip>
              )}

            {localStorage.getItem("role") == "-1" && (
              <Tooltip
                title="Download CSV of Vendor"
                onClick={() => {
                  const currentDate = new Date().toISOString().split("T")[0]; // Format as YYYY-MM-DD
                  const fileName = `vendors_data_${currentDate}.csv`;
                  downloadData(props.vendors, headersForDownload, fileName);
                }}
                // placement="left"
              >
                <IconButton>
                  <DownloadIcon />
                </IconButton>
              </Tooltip>
            )}

            {localStorage.getItem("role") == "-1" && (
              <Tooltip
                title="Download  Excel Template for Vendor Onboarding"
                onClick={downloadExcelForVendorOnboarding}
              >
                <IconButton>
                  <FileDownloadIcon />
                </IconButton>
              </Tooltip>
            )}
            {localStorage.getItem("role") == "-1" && (
              <div>
                <Tooltip title="Upload CSV for Vendor Onboarding">
                  <input
                    type="file"
                    ref={fileInputRef}
                    onChange={(e) =>
                      handleFileUploadForVendorOnboarding(
                        e,
                        props.userVenderData,
                      )
                    }
                    style={{
                      display: "none",
                    }}
                    accept=".xlsx"
                  />
                  <IconButton onClick={handleIconClick}>
                    <FileUploadIcon />
                  </IconButton>
                </Tooltip>
              </div>
            )}
            {localStorage.getItem("role") == "-1" && (
              <Tooltip title="Trash">
                <IconButton onClick={handleTrashOpen}>
                  <DeleteIcon sx={{ color: "#666666" }} />
                </IconButton>
              </Tooltip>
            )}
          </div>
        </>
      )}
      {/* Hamburger menu for mobile */}
      {isMobile && (
        <div className="flex justify-between items-center w-full">
          <Typography
            sx={{ flex: "1 1 100%" }}
            variant="p"
            id="tableTitle"
            component="div"
          >
            Total Vendor : {props.totalVendors}
          </Typography>
          {localStorage.getItem("role") != 1 && (
            <IconButton color="inherit" onClick={handleOpenModal}>
              <MenuIcon />
            </IconButton>
          )}
        </div>
      )}

      {/* Dialog Popup */}
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogContent>
          {localStorage.getItem("role") == "-1" && (
            <div className="flex justify-start border items-center mb-1 pl-3 rounded-md">
              <div className="date-filter">
                <MenuButtonWithDatePickers
                  onSubmit={handleDateChange}
                  anchorEl={anchorEl}
                  setAnchorEl={setAnchorEl}
                  // handleClose={handleDateClose}
                />
              </div>
              <div onClick={handleClick} className="w-full ">
                <p>Date Filter</p>
              </div>
            </div>
          )}
          {localStorage.getItem("role") == "-1" && (
            <div className="flex justify-start border items-center gap-1 mb-1 pl-3 rounded-md py-1">
              <div onClick={handleMapOpen}>
                <PublicIcon
                  sx={{
                    backgroundColor: props.isMapState ? "#418cff" : "inherit",
                    color: props.isMapState ? "#ffff" : "#666666",
                    borderRadius: 2,
                    strokeWidth: 1.5,
                    p: "2px",
                  }}
                />
              </div>

              <div onClick={handleMapOpen} className="w-full ">
                <p>Map View</p>
              </div>
            </div>
          )}
          {localStorage.getItem("role") == "-1" && (
            <div className="flex justify-start border items-center mb-1 pl-3 rounded-md py-1 gap-1">
              <div onClick={handleTableOpen}>
                <TableRowsIcon
                  sx={{
                    backgroundColor: props.isMapState ? "inherit" : "#418cff",
                    color: props.isMapState ? "#666666" : "#fff",
                    borderRadius: 2,
                    strokeWidth: 1.5,
                    p: "2px",
                  }}
                />
              </div>

              <div onClick={handleTableOpen} className="w-full ">
                <p>Table View</p>
              </div>
            </div>
          )}

          <div
            className="flex justify-start border items-center mb-1 p-1 rounded-md"
            onClick={handleOpen}
          >
            <Tooltip title="Add Vendor">
              <IconButton>
                <User_plus />
              </IconButton>
            </Tooltip>
            <div>
              <p>Add Vendor</p>
            </div>
          </div>

          <div
            className="date-filter flex justify-start border items-center p-1 rounded-md"
            onClick={(event) => {
              if (anchorEl) {
                // handleDateClose(); // Close the popover if it's open
              } else {
                setAnchorEl(event.currentTarget); // Open the popover
              }
            }}
          >
            {
              <IconButton>
                <MenuButtonWithDatePickers
                  onSubmit={handleDateChange}
                  anchorEl={anchorEl}
                  setAnchorEl={setAnchorEl}
                  handleClose={handleDateClose}
                  clearDateFilter={clearDateFilter}
                />
              </IconButton>
            }
            <div>
              <p>Date Filter</p>
            </div>
          </div>

          {localStorage.getItem("role") == "-1" && (
            <div
              className="flex justify-start gap-1 items-center border mb-1 rounded-md"
              onClick={() => {
                const currentDate = new Date().toISOString().split("T")[0]; // Format as YYYY-MM-DD
                const fileName = `vendors_data_${currentDate}.csv`;
                downloadData(props.vendors, headersForDownload, fileName);
              }}
            >
              <Tooltip title="Download CSV of Vendor" placement="left">
                <IconButton>
                  <DownloadIcon />
                </IconButton>
              </Tooltip>
              <div>
                <p>Download CSV </p>
              </div>
            </div>
          )}
          {localStorage.getItem("role") == "-1" && (
            <div
              className="flex justify-start border items-center mb-1 p-1 rounded-md"
              onClick={downloadExcelForVendorOnboarding}
            >
              <Tooltip title="Download  Excel Template for Vendor Onboarding">
                <IconButton>
                  <FileDownloadIcon />
                </IconButton>
              </Tooltip>
              <div>
                <p>Download Excel Template</p>
              </div>
            </div>
          )}

          {localStorage.getItem("role") == "-1" && (
            <div
              className="flex justify-start gap-1 items-center border pl-3 py-2 rounded-md"
              onClick={handleIconClick}
            >
              <input
                type="file"
                ref={fileInputRef}
                onChange={handleFileUploadForVendorOnboarding}
                style={{
                  display: "none",
                }}
                accept=".xlsx"
              />
              <div className="cursor-pointer">
                <FileUploadIcon />
              </div>
              <div>
                <p>Upload CSV </p>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}

var oldData = [];
export default function EnhancedTable() {
  // Declare states
  const navigate = useNavigate();
  const email = localStorage.getItem("superAdminEmail"); // Replace with the actual email to which the OTP should be sent
  const [otp, setOtp] = useState(Array(6).fill(""));

  const [users, setUsers] = useState([]);
  const [loadingUsers, setLoadingUsers] = useState(true);
  const [otpError, setOtpError] = useState("");
  const firstInputRef = useRef(null);
  const [isVerified, setIsVerified] = useState(false);

  const [details, setDetails] = useState(null);
  const [isModalOtpOpen, setIsModalOtpOpen] = useState(false);

  const [pageSize, setPageSize] = useState(10);
  const pageSizeOptions = [1, 5, 10, 20, 100, 200];
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const serverURL = process.env.REACT_APP_URL;
  let debounceTimeout = null;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [vendors, setVendors] = useState([]);
  const [machineCounts, setMachineCounts] = useState([]);
  const [machineImageCounts, setMachineImageCounts] = useState([]);
  const [selectedVendorData, setSelectedVendorData] = useState({});
  const [totalVendors, setTotalVendors] = useState("0");
  const [isVendorModalOpen, setIsVendorModalOpen] = useState(false);
  const [isVendorPaymentModalOpen, setIsVendorPaymentModalOpen] =
    useState(false);
  const [isActionLoading, setIsActionLoading] = useState(false);
  const [isTrashModalOpen, setIsTrashModalOpen] = useState(false);
  const [allDeletedVps, setAllDeletedVps] = useState([]);
  const [isTrashLoading, setTrashLoading] = useState(false);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [vendorPayment, setVendorPayment] = useState([]);
  const [filteredVPCount, setFilteredVPCount] = useState(0);
  const [selectedRowId, setSelectedRowId] = useState(null); // Store the selected row ID
  const [tableLoading, setTableLoading] = useState(true);

  const windowSize = 20; // always show 10 rows
  const scrollRef = useRef(null);
  const rowHeight = 45; // each row is 60px tall
  const tableRef = useRef(null);

  const [startIndex, setStartIndex] = useState(0);
  const offsetY = startIndex * rowHeight;
  const [headCells, setHeadCell] = useState([]);
  const role = localStorage.getItem("role");
  const fetchUsers = async () => {
    try {
      setLoadingUsers(true);
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${serverURL}/users/key-account-managers`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (response?.data?.success) {
        setUsers(response?.data?.data || []);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoadingUsers(false);
    }
  };

  // Call fetchUsers in useEffect
  useEffect(() => {
    fetchUsers();
  }, []);
  const getALLDeletedVps = async () => {
    try {
      setTrashLoading(true);
      const token = localStorage.getItem("token");
      const response = await axios.get(`${serverURL}/api/allDeletedVps`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response?.data?.success) {
        setAllDeletedVps(response?.data?.data);
      }
    } catch (error) {
      console.error("Error fetching InstallationPartner:", error);
    } finally {
      setTrashLoading(false);
    }
  };
  const [searchParams, setSearchParams] = useSearchParams();

  const [searchInputs, setSearchInputs] = useState({
    state: searchParams.get("state") || "",
    city: searchParams.get("city") || "",
    vendorBusinessName: searchParams.get("vendorBusinessName") || "",
    addedBy: searchParams.get("addedBy") || "",
    updatedBy: searchParams.get("updatedBy") || "",
    source: searchParams.get("source") || "",
    status: searchParams.get("status") || "",
    badge: searchParams.get("badge") || "",
    auditStatus: searchParams.get("auditStatus") || "",
    machines: searchParams.get("machines") || "",
    fromDate: searchParams.get("fromDate") || "",
    toDate: searchParams.get("toDate") || "",
    adminApproval:
      searchParams.get("adminApproval") || (role == "-1" ? "1" : "0"),
  });

  useEffect(() => {
    const headCells = [
      {
        id: "vendorBusinessName",
        label: "Business Name",
        width: 210,
      },
      {
        id: "state",
        label: "State",
        width: 150,
      },
      {
        id: "city",
        label: "City",
        width: 140,
      },

      {
        id: "gst number",
        label: "Gst Number",
        width: 160,
      },
      {
        id: "ownerName",
        label: "Owner Name",
        width: 180,
      },

      {
        id: "createdAt",
        label: "Added On",
        width: 140,
      },
      ...(role != 1
        ? [
            { id: "addedBy", label: "Added By", width: 160 },
            { id: "updatedBy", label: "Updated By", width: 160 },
          ]
        : []),

      // { id: "addedBy", label: "Added By", width: 160 },

      // { id: "updatedBy", label: " Updated By", width: 160 },
      {
        id: "source",
        label: "Source",
        width: 200,
      },
      { id: "machines", label: "Machines", width: 250 },
      {
        id: "machineImages",
        label: "Machine Images",
        width: 160,
      },
      // {
      //   id: "status",
      //   label: "Status",
      //   width: 140,
      // },
      {
        id: "badge",
        label: "Badges",
        width: 140,
      },
      ...(role == -1
        ? [
            {
              id: "assignIP",
              label: "Assign IP",
              width: 160,
            },
          ]
        : []),
      ...(role != 1
        ? [
            {
              id: "auditStatus",
              label: "Approval Status",
              width: 125,
            },
            // ["-2"].includes(String(searchInputs.adminApproval))
            //   ? {}

            //   :
            {
              id: "action",
              label: "Action",
              width: 80,
            },
          ]
        : []),
    ];

    setHeadCell(headCells);
  }, [searchInputs.adminApproval]);

  const visibleVendors = vendors?.slice(startIndex, startIndex + windowSize);
  useEffect(() => {
    setStartIndex(0);
    if (tableRef.current) {
      tableRef.current.scrollTop = 0;
    }
  }, [vendors]);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const [openAuditModal, setOpenAuditModal] = useState(false);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [selectedAuditStatus, setSelectedAuditStatus] = useState("");
  const [auditComment, setAuditComment] = useState("");
  const [auditLoading, setAuditLoading] = useState(false);
  const [openIPModal, setOpenIPModal] = useState(false);
  const [selectedVendorId, setselectedVendorId] = useState(null);

  const [approvalCount, setApprovalCount] = useState({
    approved: 0,
    rejected: 0,
    pending: 0,
  });
  useEffect(() => {
    if (approvalCount) {
      const total =
        (approvalCount.approved || 0) +
        (approvalCount.pending || 0) +
        (approvalCount.rejected || 0) +
        (approvalCount.blacklisted || 0);
      setTotalVendors(total);
    }
  }, [approvalCount]);

  const handleStatusAction = (type, vendor) => {
    setSelectedVendor(vendor);

    // type can be:
    // "APPROVE", "REJECT", "VERIFY", "UNVERIFY"

    switch (type) {
      case "APPROVE":
        setSelectedAuditStatus("Approved");
        break;
      case "REJECT":
        setSelectedAuditStatus("Rejected");
        break;

      default:
        break;
    }

    setAuditComment("");
    setOpenAuditModal(true);
  };

  const handleAuditSave = async () => {
    if (selectedAuditStatus === "Rejected" && !auditComment.trim()) {
      setSnackbar({
        open: true,
        message: "Reason is required for rejection.",
        severity: "error",
      });
      return;
    }

    try {
      setAuditLoading(true);

      const token = localStorage.getItem("token");

      let payload = {
        reason: auditComment,
      };

      // ✅ Map admin approval
      if (selectedAuditStatus === "Approved") {
        payload.status = 1;
      } else if (selectedAuditStatus === "Rejected") {
        payload.status = -1;
      }

      const response = await axios.put(
        `${serverURL}/api/updateStatus/${selectedVendor._id}`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      setSnackbar({
        open: true,
        message: `Vendor ${response?.data?.message} successfully`,
        severity: "success",
      });

      setOpenAuditModal(false);
      setSelectedVendor(null);
      setAuditComment("");

      // ✅ Re-fetch with current filters instead of getVendorList
      await refreshWithCurrentFilters();
    } catch (err) {
      console.error(err);
      setSnackbar({
        open: true,
        message: "Error updating vendor status",
        severity: "error",
      });
    } finally {
      setAuditLoading(false);
    }
  };

  const [openBlacklistModal, setOpenBlacklistModal] = useState(false);
  const [blackListReason, setBlackListReason] = useState("");
  const [blacklistLoading, setBlacklistLoading] = useState(false);
  const [isMapState, setIsMapState] = useState(false);

  const handleBlacklistSave = async () => {
    if (!blackListReason.trim()) {
      setSnackbar({
        open: true,
        message: "Reason is required to blacklist.",
        severity: "error",
      });
      return;
    }

    try {
      setBlacklistLoading(true);

      const token = localStorage.getItem("token");

      const payLoad = {
        status: -2,
        reason: blackListReason,
      };

      const response = await axios.put(
        `${serverURL}/api/updateStatus/${selectedVendor._id}`,
        payLoad,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      if (response?.data?.success) {
        setSnackbar({
          open: true,
          message: "Vendor blacklisted successfully",
          severity: "success",
        });

        // ✅ Re-fetch with current filters
        await refreshWithCurrentFilters();

        setOpenBlacklistModal(false);
        setBlackListReason("");
        setSelectedVendor(null);
      }
    } catch (error) {
      console.error("Blacklist error:", error);
      setSnackbar({
        open: true,
        message: error?.response?.data?.message || "Error blacklisting vendor",
        severity: "error",
      });
    } finally {
      setBlacklistLoading(false);
    }
  };

  const getVendorList = async (page = 1, limit = 10) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${serverURL}/api/vendors?page=${page}&limit=${limit}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      if (response?.data?.success) {
        // setTotalVendors(response?.data?.totalVendors);
        setVendors(response?.data?.vendors);
        oldData = response?.data?.vendors;
        setTotalPages(response?.data?.totalPages);
        setMachineCounts(response?.data?.machineCounts);
        setMachineImageCounts(response?.data?.machineImageCounts);
      }
    } catch (error) {
      console.error("Error fetching vendors:", error);
    }
  };

  // useEffect(() => {
  //   getVendorList(page, pageSize);
  // }, []);

  const handleModalOpen = (value) => {
    setIsModalOpen(value);
  };
  const handleDateChange = (value) => {
    if (value.dateFilter) {
      const filteredData = oldData.filter(
        (data) =>
          moment(data.createdAt)
            .tz("Asia/Kolkata")
            .format("YYYY-MM-DD HH:mm:ss") >= value.dateFilter.fromDate &&
          moment(data.createdAt)
            .tz("Asia/Kolkata")
            .format("YYYY-MM-DD HH:mm:ss") <= value.dateFilter.toDate,
      );
      setVendors(filteredData);
    } else {
      const searchTerm = value.trim().replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
      const searchKeyword = new RegExp(`\\b${searchTerm}\\w*\\b`, "i");

      if (searchKeyword === "") {
        setVendors(oldData);
      } else {
        const filteredData = oldData.filter(
          (data) =>
            searchKeyword.test(data.ownerName.toLowerCase()) ||
            searchKeyword.test(data.GSTIN.toLowerCase()) ||
            searchKeyword.test(data.city.toLowerCase()) ||
            searchKeyword.test(data.vendorBusinessName.toLowerCase()) ||
            searchKeyword.test(data.addedBy.toLowerCase()),
        );

        setVendors(filteredData);
      }
    }
  };

  const handleEditModal = (e, v, operation) => {
    setIsActionLoading(true);
    setAnchorEl(null);

    axios
      .get(`${serverURL}/api/vendors/${v._id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          let vendorData = {
            ...response.data,
            GSTIN: Decrypt(response.data.GSTIN),
            ownerName: Decrypt(response.data.ownerName),
            ownerPrimaryContactNo: Decrypt(response.data.ownerPrimaryContactNo),
            ownerSecondaryContactNo: Decrypt(
              response.data.ownerSecondaryContactNo,
            ),
          };

          setSelectedVendorData(vendorData);
          if (operation === "edit") {
            setIsModalOpen(true);
            setIsActionLoading(false);
          } else if (operation === "payments") {
            setIsVendorPaymentModalOpen(true);
            setIsActionLoading(false);
          } else {
            setIsVendorModalOpen(true);
            setIsActionLoading(false);
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching vendors:", error);
      });
  };
  const handleViewModal = (e, v, operation) => {
    setIsActionLoading(true);
    setAnchorEl(null);

    axios
      .get(`${serverURL}/api/vendors/${v}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          let vendorData = {
            ...response.data,
            GSTIN: Decrypt(response.data.GSTIN),
            ownerName: Decrypt(response.data.ownerName),
            ownerPrimaryContactNo: Decrypt(response.data.ownerPrimaryContactNo),
            ownerSecondaryContactNo: Decrypt(
              response.data.ownerSecondaryContactNo,
            ),
          };

          setSelectedVendorData(vendorData);
          if (operation === "edit") {
            setIsModalOpen(true);
            setIsActionLoading(false);
          } else if (operation === "payments") {
            setIsVendorPaymentModalOpen(true);
            setIsActionLoading(false);
          } else {
            setIsVendorModalOpen(true);
            setIsActionLoading(false);
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching vendors:", error);
      });
  };

  const handleDelete = (e, v) => {
    e.preventDefault();
    setAnchorEl(null);

    Swal.fire({
      icon: "error",
      text: "Do you want to delete?",
      showCancelButton: true,
      confirmButtonText: "Delete",
    }).then((result) => {
      if (result.isConfirmed) {
        try {
          axios
            .delete(`${serverURL}/api/vendors/${v._id}`, {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            })
            .then((response) => {
              setSnackbar({
                open: true,
                message: response.data.message,
                severity: "success",
              });
              refreshWithCurrentFilters();
            })
            .catch((error) => {
              console.error("Error deleting vendor:", error);
              Swal.fire("There was an error deleting the vendor.");
            });
        } catch (error) {
          console.error(error);
          Swal.fire("There was an error deleting the vendor.");
        }
      } else if (result.isDenied) {
        Swal.fire("Changes are not deleted", "", "info");
      }
    });
  };

  const handlePageChange = async (e, value) => {
    setPage(value); // Update the page state

    // Prepare the query params with the current search state
    const queryParams = new URLSearchParams();

    // Loop over the search inputs and add the search parameters to the query
    Object.entries(searchInputs).forEach(([key, searchValue]) => {
      if (searchValue.trim() !== "") {
        queryParams.append(key, searchValue);
      }
    });

    // Add the new page and page size to the query params
    queryParams.append("page", value);
    queryParams.append("limit", pageSize); // Assuming pageSize is the number of items per page

    // Call the API with the query params
    await fetchFilteredVendors(queryParams.toString());
  };

  const handlePageSizeChange = async (event) => {
    const newSize = parseInt(event.target.value, 10);
    setPageSize(newSize);

    const queryParams = new URLSearchParams();

    Object.entries(searchInputs).forEach(([key, searchValue]) => {
      if (searchValue.trim() !== "") {
        queryParams.append(key, searchValue);
      }
    });

    // Add the new page and page size to the query params
    queryParams.append("page", 1);
    queryParams.append("limit", newSize);

    fetchFilteredVendors(queryParams.toString()); // Fetch first page with new page size
  };

  const handleIconOpen = (event, rowId) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowId(rowId); // Set the selected row ID
  };
  const handleIconClose = () => {
    setAnchorEl(null);
    setSelectedRowId(null); // Reset the selected row ID
  };

  const handleSearchChangeHead = (e, key) => {
    let value;

    // ✅ If called from input (event)
    if (e && e.target) {
      value = e.target.value;
    }
    // ✅ If called directly (button)
    else {
      value = e;
    }

    // Normalize value (important)
    if (typeof value === "string") {
      value = value.toLowerCase();
    }
    setSearchInputs((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };
  useEffect(() => {
    const allFieldsEmpty = Object.values(searchInputs).every((val) => {
      if (typeof val === "number") {
        return false;
      }

      return String(val).trim() === "";
    });
    const timer = setTimeout(() => {
      if (scrollRef.current) {
        scrollRef.current.scrollTop = 0;
      }
      setStartIndex(0);

      if (allFieldsEmpty) {
        setFilteredVPCount(0);
        refreshWithCurrentFilters();
        return;
      }

      const queryParams = new URLSearchParams();

      Object.entries(searchInputs).forEach(([key, value]) => {
        if (value !== "" && value !== null && value !== undefined) {
          queryParams.append(key, value);
        }
      });

      queryParams.append("page", 1);
      queryParams.append("limit", pageSize);

      setSearchParams(queryParams);

      if (allFieldsEmpty) {
        setFilteredVPCount(0);
        refreshWithCurrentFilters();
        return;
      }

      fetchFilteredVendors(queryParams.toString());
    }, 300); // Debounce delay

    return () => clearTimeout(timer);
  }, [searchInputs]);

  const refreshWithCurrentFilters = async () => {
    const queryParams = new URLSearchParams();

    // Add all current search filters
    Object.entries(searchInputs).forEach(([key, searchValue]) => {
      if (searchValue && searchValue.trim() !== "") {
        queryParams.append(key, searchValue);
      }
    });

    // Add current page and page size
    queryParams.append("page", page);
    queryParams.append("limit", pageSize);

    await fetchFilteredVendors(queryParams.toString());
  };

  // Fetch vendors based on search filters
  const fetchFilteredVendors = async (queryParams) => {
    try {
      setTableLoading(true);
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${serverURL}/api/vendors?${queryParams}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      if (response?.data?.success) {
        // If machineImages filter is applied, filter the results further
        let filteredVendors = response?.data?.vendors;
        const searchParams = new URLSearchParams(queryParams);
        const machineImagesFilter = searchParams.get("machineImages");

        if (machineImagesFilter) {
          filteredVendors = filteredVendors.filter((vendor) => {
            const totalImages =
              (vendor.printingMachineImageCount || 0) +
              (vendor.fabricationMachineImageCount || 0);
            const totalMachines =
              (vendor.printingMachines || 0) +
              (vendor.fabricationMachines || 0);

            if (machineImagesFilter === "complete") {
              return totalImages >= totalMachines;
            } else if (machineImagesFilter === "incomplete") {
              return totalImages < totalMachines;
            }
            return true;
          });
        }
        // ✅ SET COUNTS HERE
        setApprovalCount(
          response?.data?.approvalCounts || {
            approved: 0,
            pending: 0,
            rejected: 0,
          },
        );
        setVendors(filteredVendors);
        setFilteredVPCount(response.data.totalVendors);
        setTotalVendors(response?.data?.entireVendorList);
        setTotalPages(response?.data?.totalPages);
        setTotalPages(response?.data?.totalPages);
        setPage(response?.data?.currentPage);
        setMachineCounts(response?.data?.machineCounts);
        setMachineImageCounts(response?.data?.machineImageCounts);
      }
    } catch (error) {
      console.error("Error fetching filtered vendors:", error);
    } finally {
      setTableLoading(false);
    }
  };

  const handleSendOtp = async (email, type) => {
    try {
      // Display a SweetAlert2 confirmation dialog
      const result = await Swal.fire({
        title: `<span className="text-2xl ">Do you want to ${
          type === "edit" ? "edit" : "view"
        } the details?</span>`,

        text: "Click 'Yes' to send OTP, or 'No' to cancel.",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6", // "Yes" button color
        cancelButtonColor: "#d33", // "No" button color
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      });

      // Check if the user clicked "Yes"
      if (result.isConfirmed) {
        // Proceed with sending OTP
        const response = await axios.post(`${serverURL}/client/send-otp`, {
          email,
        });

        // Show success alert
        await Swal.fire(
          "Success!",
          `OTP sent successfully to ${email}`,
          // 'OTP sent successfully.',
          "success",
        );

        // Open the OTP modal after successful OTP send
        setIsModalOtpOpen(true);
      } else {
        // If the user clicked "No"
        await Swal.fire("Cancelled", "OTP request cancelled.", "info");
      }
    } catch (error) {
      console.error("Error sending OTP:", error);

      // Show an error alert if something goes wrong
      await Swal.fire(
        "Error",
        "An error occurred while sending OTP. Please try again later.",
        "error",
      );
    }
  };
  const [idforView, setIdForView] = useState(null);
  const [idforEdit, setIdForEdit] = useState(null);

  const handleViewClick = (e, id, option) => {
    // if (
    //   localStorage.getItem("role") !== "-1" &&
    //   localStorage.getItem("role") !== "1" &&
    //   localStorage.getItem("role") !== "0" &&
    //   localStorage.getItem("role") !== "3"
    // ) {
    //   handleSendOtp(email, "view");
    // } else {
    handleViewModal(e, id, "read");
    // }

    setIsModalOtpOpen(false);
    setIdForView(id);
  };

  const handleEditClick = (e, id, option) => {
    // if (
    //   localStorage.getItem("role") !== "-1" &&
    //   localStorage.getItem("role") !== "1" &&
    //   localStorage.getItem("role") !== "0"
    // ) {
    //   handleSendOtp(email, "edit");
    // } else {
    handleEditModal(e, id, "edit");
    // }

    setIsModalOtpOpen(false);
    setIdForEdit(id);
  };

  const handleOtpChange = (e, index) => {
    const { value } = e.target;
    if (/^[0-9]*$/.test(value)) {
      // Allow only numeric values
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Clear error when user starts typing again
      if (otpError) {
        setOtpError("");
      }

      // Automatically focus the next input if value is entered
      if (value && index < 5) {
        const nextInput = document.getElementById(`otp-input-${index + 1}`);
        if (nextInput) nextInput.focus();
      }

      // Check if all OTP fields are filled
      const isOtpComplete = newOtp.every((digit) => digit !== "");
      setIsVerified(isOtpComplete);
    }
  };
  useEffect(() => {
    setStartIndex(0); // reset when vendor list changes
  }, [vendors]);

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (!otp[index] && index > 0) {
        // Move to previous input on backspace if current is empty
        document.getElementById(`otp-input-${index - 1}`).focus();
      } else if (otp[index]) {
        // Clear current input and stay there
        const newOtp = [...otp];
        newOtp[index] = "";
        setOtp(newOtp);
      }
    }
  };
  const handleVerifyOtp = async () => {
    try {
      const otpString = String(otp.join(""));

      // Basic validation
      if (otpString.length !== 6) {
        setOtpError("Please enter a complete 6-digit OTP");
        return;
      }

      const response = await axios.post(`${serverURL}/client/verify-otp`, {
        email,
        otp: otpString,
      });

      if (response.data.success) {
        // Check if idforView or idforEdit is set in state and call respective modal
        if (idforView) {
          handleViewModal("", idforView, "read");
        } else if (idforEdit) {
          handleEditModal("", idforEdit, "edit");
        }

        setDetails(response.data.details);
        setIsModalOtpOpen(false);
        setOtpError(""); // Clear error message on success
        setOtp(Array(6).fill(""));
        setIsVerified(false); // Reset verification state
      } else {
        setOtpError("OTP is not verified. Please try again.");
        // Clear OTP fields on error like in the reference code
        setOtp(Array(6).fill(""));
        setIsVerified(false);

        // Focus back to first input
        if (firstInputRef.current) {
          firstInputRef.current.focus();
        }
      }
    } catch (error) {
      setOtpError("OTP is not verified. Please try again.");
      // Clear OTP fields on error
      setOtp(Array(6).fill(""));
      setIsVerified(false);

      // Focus back to first input
      if (firstInputRef.current) {
        firstInputRef.current.focus();
      }

      console.error("Error verifying OTP:", error);
    }
  };
  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  function getBusinessName(role, businessName) {
    businessName = businessName || "N/A";

    if (role !== "0" && role !== "-1" && role !== "3" && role != 4) {
      return "*******" + businessName?.slice(-3);
    }

    // Default behavior for other roles
    return (
      businessName?.charAt(0).toUpperCase() +
      businessName?.slice(1).toLowerCase()
    );
  }
  const toTitleCase = (str) => {
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const handlePaymentClick = (e, v, operation) => {
    setIsActionLoading(true);
    setAnchorEl(null);
    axios
      .get(`${serverURL}/vendorPayment/getVendorPaymentDetails/${v._id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        if (response.data.success) {
          setVendorPayment(response?.data);
          setIsVendorPaymentModalOpen(true);

          setIsActionLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching Vendor:", error);

        setIsActionLoading(false);
        Swal.fire({
          text: error.response.data.message,
        });
      });
  };

  const MapFor = "vendors";

  return (
    <div className={styles.tableGround}>
      <Box>
        <Paper
          sx={{ width: "100%", boxShadow: "none" }}
          className={styles.tableGap}
        >
          <EnhancedTableToolbar
            setPageSize={setPageSize}
            userVenderData={refreshWithCurrentFilters}
            vendors={vendors}
            OnModalOpen={(value) => handleModalOpen(value)}
            setSelectedVendorData={setSelectedVendorData}
            handleSearchChangeHead={handleSearchChangeHead}
            onDateChange={(value) => handleDateChange(value)}
            totalVendors={totalVendors}
            setIsMapState={setIsMapState}
            isMapState={isMapState}
            searchInputs={searchInputs}
            setSearchInputs={setSearchInputs}
            approvalCount={approvalCount}
            getALLDeletedVendors={getALLDeletedVps}
            OnTrashModalOpen={setIsTrashModalOpen}
          />
          {isMapState ? (
            <>
              <GoogleMapModal
                setIsMapState={setIsMapState}
                locationCoordinates={vendors}
                MapFor={MapFor}
              />
            </>
          ) : (
            <>
              <TableContainer
                className={`${styles.tableContainer} ${Styles["custom-scrollbar"]}`}
                ref={tableRef}
                onScroll={(e) => {
                  const scrollTop = e.target.scrollTop;
                  const newStartIndex = Math.floor(scrollTop / rowHeight);

                  if (
                    newStartIndex !== startIndex &&
                    newStartIndex >= 0 &&
                    newStartIndex + windowSize <= vendors.length
                  ) {
                    setStartIndex(newStartIndex);
                  }
                }}
              >
                <Table stickyHeader>
                  <EnhancedTableHead
                    headCells={headCells}
                    rowCount={vendors.length}
                    userListData={refreshWithCurrentFilters}
                    setSearchInputs={setSearchInputs} // Function to update search inputs
                    handleSearchChangeHead={handleSearchChangeHead}
                    searchInputs={searchInputs}
                    machineCounts={machineCounts}
                    machineImageCounts={machineImageCounts}
                    filteredVPCount={filteredVPCount}
                    tableLoading={tableLoading}
                    OnTrashModalOpen={setIsTrashModalOpen}
                    getALLDeletedVendors={getALLDeletedVps}
                  />

                  {tableLoading ? (
                    <TableRow>
                      <TableCell colSpan={headCells?.length}>
                        <div className="flex justify-center items-center h-[70vh]">
                          <CircularProgress />
                        </div>
                      </TableCell>
                    </TableRow>
                  ) : !visibleVendors || visibleVendors?.length == 0 ? (
                    <TableRow>
                      <TableCell
                        colSpan={headCells?.length}
                        sx={{ borderBottom: "none" }}
                      >
                        <div className="flex justify-center items-center h-64">
                          No Vendor found
                        </div>
                      </TableCell>
                    </TableRow>
                  ) : (
                    <TableBody>
                      <TableRow
                        style={{ height: `${startIndex * rowHeight}px` }}
                      >
                        <TableCell
                          colSpan={10}
                          style={{ padding: 0, border: "none" }}
                        />
                      </TableRow>
                      {visibleVendors.map((v, index) => {
                        const status = Number(v.adminApproval ?? 0);
                        const isActionAllowed =
                          status === 1 ||
                          status === 0 ||
                          status === -1 ||
                          status === -2;
                        return (
                          <TableRow
                            hover
                            className={styles.tableRowHead}
                            tabIndex={-1}
                            key={v._id}
                            onClick={(e) => {
                              // Check if the click was on the source column (8th column) or action column
                              const clickedCell = e.target.closest("td");
                              const isSourceColumn =
                                clickedCell && clickedCell.cellIndex === 7;
                              const isActionColumn =
                                clickedCell &&
                                clickedCell.cellIndex === headCells.length - 1;

                              if (!isSourceColumn && !isActionColumn) {
                                // handleViewClick(e, v._id, "read");
                                // navigate(`/adminPortal/vendorDetails/${v._id}`);
                                navigate(
                                  `/adminportal/vendorDetails/${v._id}?${new URLSearchParams(
                                    searchInputs,
                                  ).toString()}`,
                                );
                              }
                            }}
                          >
                            <TableCell className={styles.tableRow}>
                              {(() => {
                                const businessName =
                                  v.vendorBusinessName || "N/A";
                                const fullBusinessName = toTitleCase(
                                  getBusinessName(role, businessName),
                                );

                                const truncatedName =
                                  fullBusinessName.length > 27
                                    ? fullBusinessName.substring(0, 25) + "..."
                                    : fullBusinessName;

                                return (
                                  <div className="flex">
                                    {v.badge != "None" &&
                                      v.badge != undefined &&
                                      v.badge != null &&
                                      v.badge != "" && (
                                        <img
                                          src={
                                            v.badge === "Platinum"
                                              ? "/assests/AdminDashboard/diamond.png"
                                              : v.badge === "Gold"
                                                ? "/assests/AdminDashboard/gold.png"
                                                : v.badge === "Silver"
                                                  ? "/assests/AdminDashboard/silver.png"
                                                  : ""
                                          }
                                          alt="badge"
                                          style={{
                                            width: "40px",
                                            height: "40px",
                                            objectFit: "contain",
                                          }}
                                        />
                                      )}
                                    <Tooltip
                                      title={fullBusinessName}
                                      arrow
                                      placement="top"
                                    >
                                      <span>{truncatedName}</span>
                                    </Tooltip>
                                  </div>
                                );
                              })()}
                            </TableCell>
                            <TableCell className={styles.tableRow}>
                              {(() => {
                                const stateName = v.state || "N/A";

                                // Truncate if length > 18
                                const truncatedState =
                                  stateName.length > 13
                                    ? stateName?.slice(0, 13) + "..."
                                    : stateName;

                                return (
                                  <Tooltip
                                    title={
                                      stateName.length > 13 ? stateName : ""
                                    }
                                    arrow
                                    placement="top"
                                  >
                                    <span>{truncatedState}</span>
                                  </Tooltip>
                                );
                              })()}
                            </TableCell>
                            <TableCell className={styles.tableRow}>
                              {(() => {
                                const cityName = v.city || "N/A";

                                // Truncate if length > 18
                                const truncatedCity =
                                  cityName.length > 10
                                    ? cityName?.slice(0, 10) + "..."
                                    : cityName;

                                return (
                                  <Tooltip
                                    title={cityName.length > 10 ? cityName : ""}
                                    arrow
                                    placement="top"
                                  >
                                    <span>{truncatedCity}</span>
                                  </Tooltip>
                                );
                              })()}
                            </TableCell>

                            <TableCell className={styles.tableRow}>
                              <span>
                                {role === "-1" ||
                                role === "0" ||
                                role == 4 ||
                                role == "3"
                                  ? v?.GSTIN
                                  : `*******${Decrypt(v?.GSTIN)?.slice(-4)}`}
                              </span>
                            </TableCell>
                            <TableCell className={styles.tableRow}>
                              {(() => {
                                let displayName;
                                let fullName =
                                  role === "-1" ||
                                  role === "0" ||
                                  role === "3" ||
                                  role == 4
                                    ? v?.ownerName
                                    : Decrypt(v?.ownerName) || "N/A"; // Handle empty ownerName

                                // Apply the logic based on role
                                if (
                                  role === "-1" ||
                                  role === "0" ||
                                  role == 4 ||
                                  role === "3"
                                ) {
                                  fullName =
                                    fullName?.charAt(0).toUpperCase() +
                                    fullName?.slice(1);
                                } else {
                                  fullName = `******${fullName?.slice(-5)}`;
                                }

                                // Extract initials (First letter of first and second words)
                                const nameParts = fullName
                                  ? fullName?.split(" ")
                                  : "N/A";
                                let initials =
                                  nameParts[0]?.charAt(0)?.toUpperCase() || "";
                                // if (nameParts.length > 1) {
                                //   initials += nameParts[1]?.charAt(0)?.toUpperCase();
                                // }

                                // Truncate if length > 10
                                displayName =
                                  fullName.length > 12
                                    ? fullName?.slice(0, 12) + "..."
                                    : fullName;

                                return (
                                  <Tooltip
                                    title={fullName.length > 15 ? fullName : ""}
                                    arrow
                                    placement="top"
                                  >
                                    <span className="flex flex-row items-center">
                                      <Avatar
                                        style={{
                                          background: "#e8f1ff",
                                          color: "#1488ef",
                                        }}
                                        variant="rounded"
                                        sx={{ width: 32, height: 32 }}
                                      >
                                        <span className="text-sm">
                                          {initials}
                                        </span>
                                      </Avatar>

                                      <span>{displayName}</span>
                                    </span>
                                  </Tooltip>
                                );
                              })()}
                            </TableCell>

                            <TableCell className={styles.tableRow}>
                              {" "}
                              <FormatDateTimestamp timestamp={v.createdAt} />
                            </TableCell>

                            {role !== "1" && (
                              <>
                                <TableCell className={styles.tableRow}>
                                  {(() => {
                                    let addedByName = v?.addedBy?.name
                                      ? v?.addedBy?.name
                                          ?.charAt(0)
                                          .toUpperCase() +
                                        v?.addedBy?.name?.slice(1)
                                      : "Self";

                                    // Truncate if length > 18
                                    const truncatedName =
                                      addedByName.length > 18
                                        ? addedByName?.slice(0, 18) + "..."
                                        : addedByName;

                                    return (
                                      <Tooltip
                                        title={
                                          addedByName.length > 18
                                            ? addedByName
                                            : ""
                                        }
                                        arrow
                                        placement="top"
                                      >
                                        <span>{truncatedName}</span>
                                      </Tooltip>
                                    );
                                  })()}
                                </TableCell>
                                <TableCell className={styles.tableRow}>
                                  {(() => {
                                    let updatedByName = v?.updatedBy?.name
                                      ? v?.updatedBy?.name
                                          ?.charAt(0)
                                          .toUpperCase() +
                                        v?.updatedBy?.name?.slice(1)
                                      : "N/A"; // Fallback to "N/A" if updatedBy is not populated

                                    // Truncate if length > 18
                                    const truncatedName =
                                      updatedByName.length > 18
                                        ? updatedByName?.slice(0, 18) + "..."
                                        : updatedByName;

                                    return (
                                      <Tooltip
                                        title={
                                          updatedByName.length > 18
                                            ? updatedByName
                                            : ""
                                        }
                                        arrow
                                        placement="top"
                                      >
                                        <span>{truncatedName}</span>
                                      </Tooltip>
                                    );
                                  })()}
                                </TableCell>
                              </>
                            )}

                            <TableCell
                              className={styles.tableRow}
                              onClick={(e) => {
                                e.stopPropagation(); // Prevent row click event
                              }}
                            >
                              {(() => {
                                // Check if addedBy is null/undefined (app onboarded)
                                const isAddedBySelf = !v?.addedBy?.name;

                                // If added by is "Self" (app onboarded), show ReferenceAssignmentModal
                                if (isAddedBySelf) {
                                  return (
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                      }}
                                      onClick={(e) => e.stopPropagation()} // Another layer of protection
                                    >
                                      <VendorReferenceAssignmentModal
                                        vendorData={v}
                                        getVendorList={
                                          refreshWithCurrentFilters
                                        }
                                        initialSourceUser={v?.sourceUser}
                                        users={users}
                                        onChange={() => {
                                          refreshWithCurrentFilters();
                                        }}
                                        userRole={userRole}
                                      />
                                    </div>
                                  );
                                } else {
                                  // If not "Self", show the sourceUser information if it exists
                                  if (v?.sourceUser?.name) {
                                    const sourceUserName =
                                      v.sourceUser.name
                                        .charAt(0)
                                        .toUpperCase() +
                                      v.sourceUser.name.slice(1);
                                    return (
                                      <Tooltip
                                        title={sourceUserName}
                                        arrow
                                        placement="top"
                                      >
                                        <div
                                          style={{ textAlign: "center" }}
                                          onClick={(e) => e.stopPropagation()} // Prevent row click
                                        >
                                          <span className="font-medium">
                                            {sourceUserName}
                                          </span>
                                        </div>
                                      </Tooltip>
                                    );
                                  } else {
                                    // Show empty state for admin-created vendors without source user
                                    return (
                                      <span
                                        className="text-gray-400"
                                        onClick={(e) => e.stopPropagation()} // Prevent row click
                                      >
                                        Admin
                                      </span>
                                    );
                                  }
                                }
                              })()}
                            </TableCell>

                            <TableCell className={styles.tableRow}>
                              <span className="flex justify-evenly justify-self-start gap-2">
                                {v?.printingMachines ? (
                                  <Chip
                                    label="Printing"
                                    className={`${styles.machineChip} ${
                                      v.printingMachines === "Printing"
                                        ? styles.active
                                        : styles.inactive
                                    }`}
                                  />
                                ) : null}

                                {v?.fabricationMachines ? (
                                  <Chip
                                    label="Fabrication"
                                    className={`${styles.machineChip} ${styles.fabricationChip}`}
                                  />
                                ) : null}
                              </span>
                            </TableCell>
                            <TableCell className={styles.tableRow}>
                              <div className="flex justify-center">
                                {v?.fabricationMachineImageCount +
                                  v?.printingMachineImageCount}
                                /{v.printingMachines + v.fabricationMachines}
                              </div>
                            </TableCell>
                            {/* <TableCell className={styles.tableRow}>
                              <span>
                                <Chip
                                  label={v?.status || "N/A"}
                                  className={`${styles.chipStatus} ${v?.status === "Active"
                                    ? styles.active
                                    : v?.status === "Inactive"
                                      ? styles.inactive
                                      : v?.status === "Blacklisted"
                                        ? styles.blacklisted
                                        : ""
                                    }`}
                                />
                              </span>
                            </TableCell> */}
                            <TableCell className={styles.tableRow}>
                              <span>
                                <Chip
                                  label={v?.badge || "N/A"}
                                  className={`${styles.chipStatus} ${
                                    v?.badge === "Platinum"
                                      ? styles.platinum
                                      : v?.badge === "Gold"
                                        ? styles.gold
                                        : v?.badge === "Silver"
                                          ? styles.silver
                                          : "No Badge"
                                  }`}
                                />
                              </span>
                            </TableCell>

                            {role == -1 && (
                              <TableCell
                                className={styles.tableRow}
                                onClick={(e) => e.stopPropagation()}
                              >
                                <Box className="flex items-center gap-2">
                                  <Tooltip title="Assign Installation Partner">
                                    <IconButton
                                      size="small"
                                      onClick={(e) => {
                                        e.stopPropagation();

                                        setselectedVendorId(v);
                                        setOpenIPModal(true); // 👈 modal open
                                      }}
                                    >
                                      <PersonAddAlt fontSize="small" />
                                    </IconButton>
                                  </Tooltip>

                                  <Tooltip
                                    title={
                                      v?.assignedIps?.length > 0 ? (
                                        <div>
                                          {v?.assignedIps.map((s, i) => (
                                            <div key={s?.id ?? i}>
                                              {i + 1}. {s?.name}
                                            </div>
                                          ))}
                                        </div>
                                      ) : (
                                        "No IP Assigned"
                                      )
                                    }
                                    arrow
                                  >
                                    <span style={{ display: "inline-block" }}>
                                      {v?.assignedIps?.length > 0
                                        ? `${v?.assignedIps[0]?.name}${
                                            v.assignedIps.length > 1
                                              ? ` +${v.assignedIps.length - 1}`
                                              : ""
                                          }`
                                        : "Select IP"}
                                    </span>
                                  </Tooltip>
                                </Box>
                              </TableCell>
                            )}
                            {role !== "1" && (
                              <>
                                <TableCell
                                  onClick={(e) => e.stopPropagation()}
                                  className={styles.tableRow}
                                >
                                  {(() => {
                                    const role = localStorage.getItem("role");
                                    const status =
                                      v.adminApproval === undefined
                                        ? 0
                                        : v.adminApproval; // treat old records as pending

                                    const reason =
                                      status === -2
                                        ? v.reasonForBlacklisted
                                        : v.adminApprovalReason;

                                    const showTooltip = reason && reason.trim();

                                    const wrapWithTooltip = (component) => (
                                      <Tooltip
                                        title={
                                          status === -2
                                            ? `Blacklist: ${reason}`
                                            : status === -1
                                              ? `Rejected: ${reason}`
                                              : status === 1
                                                ? `Approved: ${reason || "No reason provided"}`
                                                : `Pending`
                                        }
                                      >
                                        {component}
                                      </Tooltip>
                                    );

                                    const currentFilter =
                                      searchInputs.adminApproval; // Get current tab filter

                                    // ✅ APPROVED
                                    if (status === 1) {
                                      return wrapWithTooltip(
                                        <Chip
                                          label="Approved"
                                          color="success"
                                          size="small"
                                        />,
                                      );
                                    }

                                    // ❌ REJECTED
                                    if (status === -1) {
                                      return wrapWithTooltip(
                                        <Chip
                                          label="Rejected"
                                          color="error"
                                          size="small"
                                        />,
                                      );
                                    }

                                    //Blacklisted
                                    if (status === -2) {
                                      return wrapWithTooltip(
                                        <Chip
                                          label="Blacklisted"
                                          size="small"
                                          sx={{
                                            backgroundColor: "#000",
                                            color: "#fff",
                                          }}
                                        />,
                                      );
                                    }

                                    // ⏳ PENDING
                                    if (status === 0) {
                                      // Only super admin can take action
                                      if (currentFilter === "0") {
                                        if (role === "-1") {
                                          return (
                                            <div className="flex gap-2">
                                              <GlobalButton
                                                variant="primary"
                                                size="small"
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  handleStatusAction(
                                                    "APPROVE",
                                                    v,
                                                  );
                                                }}
                                              >
                                                {`Approve`}
                                              </GlobalButton>

                                              <GlobalButton
                                                variant="warning"
                                                size="small"
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  handleStatusAction(
                                                    "REJECT",
                                                    v,
                                                  );
                                                }}
                                              >
                                                {`Reject`}
                                              </GlobalButton>
                                            </div>
                                          );
                                        }

                                        // Other roles → just show pending
                                        return wrapWithTooltip(
                                          <Chip
                                            label="Pending"
                                            color="warning"
                                            size="small"
                                          />,
                                        );
                                      }
                                    }

                                    return null;
                                  })()}
                                </TableCell>
                              </>
                            )}

                            {role !== "1" && (
                              <TableCell
                                className={styles.tableRow}
                                onClick={(e) => {
                                  e.stopPropagation();
                                }}
                              >
                                <div className="flex justify-center">
                                  <Tooltip title="Click">
                                    {/* {isActionAllowed && ( */}
                                    <IconButton
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleIconOpen(e, v._id);
                                      }}
                                    >
                                      <MoreVertIcon
                                        style={{
                                          color: "var(--primary-color)",
                                        }}
                                      />
                                    </IconButton>
                                    {/* )} */}
                                  </Tooltip>
                                </div>
                                <Menu
                                  anchorEl={anchorEl}
                                  open={
                                    Boolean(anchorEl) && selectedRowId === v._id
                                  }
                                  onClose={handleIconClose}
                                  keepMounted
                                >
                                  {/* Details Section */}
                                  {isVerified && details && (
                                    <div style={{ marginTop: "2rem" }}>
                                      <h3>Details:</h3>
                                      <pre>
                                        {JSON.stringify(details, null, 2)}
                                      </pre>
                                    </div>
                                  )}

                                  {(userRole == -1 ||
                                    ((userRole == 0 || userRole == 3) &&
                                      status == 0)) && (
                                    <MenuItem
                                      onClick={(e) => {
                                        handleEditClick(e, v, "edit");
                                        handleIconClose(); // Close the menu
                                        setIdForView(null);
                                      }}
                                      disabled={isActionLoading}
                                    >
                                      <EditOutlinedIcon
                                        style={{ color: "#6b7280" }}
                                      />
                                      <p className="ml-2 font-semibold text-[#6b7280]">
                                        Edit
                                      </p>
                                    </MenuItem>
                                  )}
                                  {/* Show Payments ONLY for super admin AND only when vendor is Approved (status === 1) */}
                                  {localStorage.getItem("role") == "-1" &&
                                    v.adminApproval !== -1 &&
                                    v.adminApproval !== -2 && (
                                      <MenuItem
                                        onClick={(e) =>
                                          handlePaymentClick(e, v, "payments")
                                        }
                                      >
                                        <CurrencyRupeeOutlinedIcon
                                          style={{ color: "#6b7280" }}
                                        />
                                        <p className="ml-2 font-semibold text-[#6b7280]">
                                          Payments
                                        </p>
                                      </MenuItem>
                                    )}
                                  {/* Show Delete ONLY for super admin AND only when vendor is Approved (status === 1) */}
                                  {localStorage.getItem("role") == "-1" &&
                                    v.adminApproval === 1 && (
                                      <MenuItem
                                        onClick={(e) => handleDelete(e, v)}
                                        style={{ color: "red" }}
                                      >
                                        <DeleteOutlinedIcon
                                          style={{ color: "red" }}
                                        />{" "}
                                        <p className="ml-2 font-semibold text-[red]">
                                          Delete
                                        </p>
                                      </MenuItem>
                                    )}
                                  {/* Show Blacklist ONLY for super admin AND only when vendor is Approved (status === 1) and not already blacklisted */}
                                  {localStorage.getItem("role") == "-1" &&
                                    v.adminApproval == 1 && (
                                      <MenuItem
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setSelectedVendor(v);
                                          setBlackListReason("");
                                          setOpenBlacklistModal(true);
                                          setAnchorEl(null);
                                        }}
                                        style={{ color: "red" }}
                                      >
                                        <BlockIcon
                                          style={{ color: "red" }}
                                          fontSize="small"
                                        />
                                        <p className="ml-2 font-semibold text-[red]">
                                          Blacklist
                                        </p>
                                      </MenuItem>
                                    )}
                                  {((localStorage.getItem("role") == "-1" &&
                                    v.adminApproval == -2) ||
                                    (localStorage.getItem("role") == "-1" &&
                                      v.adminApproval == -1)) && (
                                    <MenuItem
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleStatusAction("APPROVE", v);
                                        setAnchorEl(null);
                                      }}
                                      style={{ color: "green" }}
                                    >
                                      <CheckCircle
                                        style={{ color: "green" }}
                                        fontSize="small"
                                      />
                                      <p className="ml-2 font-semibold text-[green]">
                                        Approve
                                      </p>
                                    </MenuItem>
                                  )}
                                </Menu>
                              </TableCell>
                            )}
                          </TableRow>
                        );
                      })}
                      <TableRow
                        style={{
                          height: `${
                            (vendors.length - startIndex - windowSize) *
                            rowHeight
                          }px`,
                        }}
                      >
                        <TableCell
                          colSpan={10}
                          style={{ padding: 0, border: "none" }}
                        />
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
              <hr
                className="mt-2 bg-gray-200 "
                style={{ border: "0.5px solid var(--light-grey-color)" }}
              />

              <div className="flex items-center justify-between ">
                <FormControl
                  variant="standard"
                  size="small"
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 1,
                    "& .MuiInputBase-root:before": { borderBottom: "none" },
                    "& .MuiInputBase-root:after": { borderBottom: "none" },
                    "& .MuiInputBase-root": { marginTop: 1 }, // 👈 override here
                  }}
                >
                  <InputLabel
                    id="page-size-label"
                    sx={{
                      position: "static",
                      transform: "none",
                      fontSize: "14px",
                      marginRight: "8px",
                      marginTop: "2px",
                    }}
                  >
                    Rows
                  </InputLabel>
                  <GlobalDropdownField
                    variant={"citySelect"}
                    value={pageSize}
                    onChange={handlePageSizeChange}
                    options={pageSizeOptions.map((size) => ({
                      value: size,
                      label: `${size}`,
                    }))}
                  />
                </FormControl>
                <GlobalSnackbar
                  snackbar={snackbar}
                  handleClose={handleSnackbarClose}
                />
                <Pagination
                  className="p-2 flex justify-center"
                  count={totalPages}
                  page={page}
                  onChange={handlePageChange}
                  sx={{
                    "& .MuiPaginationItem-root.Mui-selected": {
                      backgroundColor: "#418cff", // Blue background for selected
                      color: "#fff", // White text for selected
                    },
                    "& .MuiPaginationItem-root.Mui-selected:hover": {
                      backgroundColor: "#3366cc", // Darker blue on hover
                    },
                    "& .MuiPaginationItem-root": {
                      "&:hover": {
                        backgroundColor: "#ddd", // Light gray for hovered items
                      },
                    },
                  }}
                />
              </div>
            </>
          )}
        </Paper>
      </Box>

      {isActionLoading ? (
        <CustomLoading />
      ) : (
        isModalOpen && (
          <VendorOnboardingForm
            getVendorList={refreshWithCurrentFilters}
            isModalOpen={isModalOpen}
            setSnackbar={setSnackbar}
            setIsModalOpen={setIsModalOpen}
            selectedVendorData={selectedVendorData}
            setSelectedVendorData={setSelectedVendorData}
          />
        )
      )}

      {isActionLoading ? (
        <CustomLoading />
      ) : (
        isVendorModalOpen && (
          <VendorModal
            isVendorModalOpen={isVendorModalOpen}
            setIsVendorModalOpen={setIsVendorModalOpen}
            selectedVendorData={selectedVendorData}
            setSelectedVendorData={setSelectedVendorData}
            setSnackbar={setSnackbar}
            snackbar={snackbar}
            setAnchorEl={setAnchorEl}
            fetchFilteredVendors={fetchFilteredVendors}
          />
        )
      )}
      {isActionLoading ? (
        <CustomLoading />
      ) : (
        isTrashModalOpen && (
          <DeletedUsersRestore
            list={allDeletedVps}
            type="VENDOR"
            openModal={isTrashModalOpen}
            loading={isTrashLoading}
            getAllDeletedUsers={getALLDeletedVps}
            setIsTrashModalOpen={setIsTrashModalOpen}
            setTrashLoading={setTrashLoading}
            getAllList={refreshWithCurrentFilters}
          />
        )
      )}
      {isActionLoading ? (
        <CustomLoading />
      ) : (
        isVendorPaymentModalOpen && (
          <VendorPaymentsModal
            isVendorPaymentModalOpen={isVendorPaymentModalOpen}
            setIsVendorPaymentModalOpen={setIsVendorPaymentModalOpen}
            selectedVendorData={vendorPayment}
            setSelectedVendorData={setSelectedVendorData}
          />
        )
      )}
      {/* OTP Verification Modal */}
      <OtpVerificationModal
        isOpen={isModalOtpOpen}
        onClose={() => setIsModalOtpOpen(false)}
        otp={otp}
        handleOtpChange={handleOtpChange}
        handleKeyDown={handleKeyDown}
        firstInputRef={firstInputRef}
        isVerified={isVerified}
        handleVerifyOtp={handleVerifyOtp}
        otpError={otpError}
      />
      {openIPModal && (
        <IPAssignModal
          open={openIPModal}
          onClose={() => {
            setOpenIPModal(false);
            setselectedVendorId(null);
          }}
          initialSelected={selectedVendorId?.assignedIps || null}
          vendorId={selectedVendorId}
          getVendorList={refreshWithCurrentFilters}
        />
      )}
      {/* Audit Modal */}
      <Dialog
        open={openAuditModal}
        onClose={() => setOpenAuditModal(false)}
        fullWidth
      >
        <DialogTitle>
          {selectedAuditStatus === "Approved"
            ? "Approve Vendor"
            : selectedAuditStatus === "Rejected"
              ? "Reject Vendor"
              : "Unapprove Vendor"}
        </DialogTitle>

        <DialogContent>
          <TextField
            fullWidth
            multiline
            rows={4}
            placeholder={
              selectedAuditStatus === "Rejected"
                ? "Reason for rejection (mandatory)"
                : "Enter comment (optional)"
            }
            value={auditComment}
            onChange={(e) => setAuditComment(e.target.value)}
            required={selectedAuditStatus === "Rejected"} // ✅ important
          />
        </DialogContent>

        <DialogActions>
          <div className="flex items-center gap-2">
            <GlobalButton
              variant="secondary"
              size="medium"
              onClick={() => setOpenAuditModal(false)}
            >
              Cancel
            </GlobalButton>
            <GlobalButton
              variant="primary"
              size="medium"
              disabled={
                selectedAuditStatus === "Rejected" && !auditComment.trim()
              }
              isLoading={auditLoading}
              onClick={handleAuditSave}
            >
              {selectedAuditStatus === "Approved"
                ? "Approve"
                : selectedAuditStatus === "Rejected"
                  ? "Reject"
                  : "Unapprove"}
            </GlobalButton>
          </div>
        </DialogActions>
      </Dialog>

      {/* Blacklist Modal */}
      <Dialog
        open={openBlacklistModal}
        onClose={() => setOpenBlacklistModal(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Blacklist Vendor</DialogTitle>

        <DialogContent>
          <TextField
            fullWidth
            multiline
            rows={4}
            placeholder="Enter reason for blacklisting (mandatory)"
            value={blackListReason}
            onChange={(e) => setBlackListReason(e.target.value)}
            required
          />
        </DialogContent>

        <DialogActions>
          <div className="flex items-center gap-2 ">
            <GlobalButton
              variant="secondary"
              size="medium"
              onClick={() => setOpenBlacklistModal(false)}
            >
              Cancel
            </GlobalButton>
            <GlobalButton
              variant="primary"
              size="medium"
              disabled={blacklistLoading || !blackListReason.trim()}
              isLoading={blacklistLoading}
              onClick={handleBlacklistSave}
            >
              Confirm Blacklist
            </GlobalButton>
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
}

const headersForDownload = [
  { label: "State", key: "state" },
  { label: "Division", key: "division" },
  { label: "District", key: "district" },
  { label: "City", key: "city" },
  { label: "Vendor Business Name", key: "vendorBusinessName" },
  { label: "Pin Code", key: "pinCode" },
  { label: "Type of Business", key: "typeOfBusiness" },
  { label: "Owner Name", key: "ownerName" },
  { label: "Owner Primary Contact No", key: "ownerPrimaryContactNo" },
  { label: "Owner Secondary Contact No", key: "ownerSecondaryContactNo" },
  { label: "Address", key: "address" },
  { label: "Email Address", key: "emailAddress" },
  { label: "Website", key: "website" },
  { label: "Reliability", key: "reliability" },
  { label: "Years in Business", key: "yearsInBusiness" },
  { label: "Number of Employees", key: "numberOfEmployees" },
  { label: "Number of Skilled Manpower", key: "numberOfSkilledManpower" },
  { label: "Number of Unskilled Manpower", key: "numberOfUnskilledManpower" },
  { label: "Registered in ESI PF", key: "registeredInESIPF" },
  { label: "GSTIN", key: "GSTIN" },
  { label: "PAN Number", key: "PANNumber" },
  { label: "Bank Account Number", key: "bankAccountNumber" },
  { label: "Bank Name", key: "bankName" },
  { label: "Bank IFSC Code", key: "bankIFSCCode" },
  { label: "Avg Turnover Last 3 Years", key: "avgTurnoverLast3Years" },
  { label: "Production Area", key: "productionArea" },
  { label: "Payment Terms", key: "paymentTerms" },
  { label: "Scaling Factors", key: "scalingFactors" },
];
